import {  filterSelectedActions } from '../../services';


export const filterSelectedReducer = ( state = {show:false}, action ) => {
  switch ( action.type ) {
    case filterSelectedActions.FILTERSELECTED:
        return {...state, ["show"]:action.value};
    default:
        return state;
  }
};